import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { PROPS, DEFAULTPROPS } from "./props";

const SFSvgIcon = (props) => {
  const {size, ...other} = props;
  return (
    <SvgIcon
      {...(props.component && { component: props.component })}
      fontSize={size}
      color={props.color}
      {...other}
    >
      {props.children}
    </SvgIcon>
  );
};

SFSvgIcon.defaultProps = DEFAULTPROPS;

SFSvgIcon.propTypes = PROPS;

export default SFSvgIcon;
